import { SearchFilter, Pagination } from '@fs/zion-rootstech'
import { getMinDashboardSessionDetail } from './SessionDetail'

export { getSessionSearch, SessionSearch } from '@fs/zion-rootstech'

export const getDashboardSessionSearch = (includeAudiences = false) => `
  ${SearchFilter}
  ${Pagination}
  ${getMinDashboardSessionDetail(includeAudiences)}
  fragment DashboardSessionSearch on SessionSearch {
    filters {
      ...SearchFilter
    }
    paginationData {
      ...Pagination
    }
    results {
      ...MinDashboardSessionDetail
    }
  }
`
